import CircleType from 'circletype'
export default class FooterScrollTopService {
    constructor() {
        const $scrollTop = $('.footer__scroll-top')

        // Scroll to top action management
        $scrollTop.on('click', () => {
            window.scrollTo({ top: 0, behavior: 'smooth' })
        })

        // Text curvature management
        // Using circletype to allow translations https://circletype.labwire.ca/
        new CircleType($('.footer__scroll-top p')[0]).dir(-1).radius(65)

        // Change arrow CSS if js is enabled (to adapt for text curvature)
        $scrollTop.find('i').css('position', 'absolute').css('translate', '-50% -7.5px')
    }
}
